enum LoaderType {

    FullScreen = "fullScreen",
    TopBarLess = "topBarLess",
    MenuLess = "menuLess",
    Local = "local"
}

export {LoaderType};
